import { createSelectableAddendumItem } from "../AddendumSection/addendumSection.utils";

export const sortBlockChapters = (chapters) => {
  return chapters.sort((a, b) => {
    const chapterA = Number(a.number) || 0;
    const chapterB = Number(b.number) || 0;

    return chapterA - chapterB;
  });
};

export const getAllAttachments = (bloco) => {
  const chapterAttachments = (bloco.chapters || []).flatMap((ch) =>
    (ch.attachments || []).map((a) => ({
      ...a,
      id: a.id ?? a.fileId,
      parentId: ch.id,
      blockId: bloco.id,
      blockNumber: bloco.number,
      chapterNumber: ch.number,
      type: "chapter",
      versionNumber: a.version,
    }))
  );

  // These addenda belong to chapters (long-form dramaturgy), so they resolve
  // associations via the chapter lookup - see addendumSection.utils.js.
  const addendums = (bloco.chapters || [])
    .flatMap((ch) => ch.addenda || [])
    .map((addendum) => createSelectableAddendumItem(addendum, true));

  return [...chapterAttachments, ...addendums];
};

export const isSelected = (id, selectedFileIds) => selectedFileIds.has(id);

export const toggleManyReducer = (prev, attachments) => {
  const prevIds = new Set(prev.map((f) => f.id));
  const allSelected = attachments.every((a) => prevIds.has(a.id));

  if (allSelected) {
    const removeIds = new Set(attachments.map((a) => a.id));
    return prev.filter((f) => !removeIds.has(f.id));
  }

  const newOnes = attachments.filter((a) => !prevIds.has(a.id));

  return [...prev, ...newOnes];
};

export const getBlockSelectionState = (allAttachments, selectedFileIds) => {
  const allSelected =
    allAttachments.length > 0 &&
    allAttachments.every((a) => isSelected(a.id, selectedFileIds));

  const someSelected =
    allAttachments.some((a) => isSelected(a.id, selectedFileIds)) &&
    !allSelected;

  return { allSelected, someSelected };
};
